'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _startsWith = require('lodash/startsWith');

var _startsWith2 = _interopRequireDefault(_startsWith);

var _PlatformApi2 = require('./PlatformApi');

var _PlatformApi3 = _interopRequireDefault(_PlatformApi2);

var _reportIds = require('../constants/reportIds');

var _reportIds2 = _interopRequireDefault(_reportIds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable sort-keys */
var endpoints = {
  publisher: {
    campaigns: {
      one: '/{record}/campaigns',
      params: {
        record: 'publisher'
      },
      queryParams: ['campaign_ids', 'source']
    }
  },
  benchmarks: {
    many: '/intelligence/benchmarks',
    queryParams: ['async', 'columns', 'currency_code', 'dates', 'email', 'filename', 'format', 'pmn_brand_id', 'pmn_company_id', 'pub_objective', 'publisher', 'vertical']
  },
  adAccounts: {
    search: {
      many: '/resources/ad_accounts',
      queryParams: ['pacing_report', 'publisher', 'search']
    }
  },
  brands: {
    customConversions: {
      one: '/brands/{record}/custom_conversions',
      params: {
        record: 'brandId'
      }
    }
  },
  campaigns: {
    pacing: {
      stats: {
        many: '/campaigns/pacing',
        queryParams: ['brand_id', 'campaign_name', 'flight_status', 'limit', 'line_item_id_filter', 'offset', 'optimization_goal', 'optimization_last_status', 'optimization_recipe', 'optimization_status', 'order_by', 'publisher', 'true_pacing_status', 'user_id', 'adaccount_id', 'company_id', 'family_id']
      },
      summary: {
        many: '/campaigns/pacing/summary',
        queryParams: ['brand_id', 'campaign_name', 'flight_status', 'line_item_id_filter', 'optimization_goal', 'optimization_last_status', 'optimization_recipe', 'optimization_status', 'publisher', 'true_pacing_status', 'user_id', 'adaccount_id', 'company_id', 'family_id']
      }
    }
  },
  customer: {
    businessOrganization: {
      many: '/customer/business_organization',
      queryParams: ['client_name', 'dataset_name', 'format_type']
    }
  },
  dashboards: {
    ihmCampaign: {
      campaigns: {
        one: '/dashboards/ihm_campaign/campaign/{record}',
        params: {
          record: 'campaignId'
        }
      },
      initiativesList: {
        many: '/dashboards/ihm_campaign/initiatives_list'
      },
      initiatives: {
        many: '/dashboards/ihm_campaign/initiatives',
        one: '/dashboards/ihm_campaign/initiatives/{record}',
        params: {
          record: 'initiativeId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_line_item_ids'],
        summary: {
          one: '/dashboards/ihm_campaign/initiatives/{record}/summary',
          params: {
            record: 'initiativeId'
          }
        },
        xandr: {
          dayPart: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/xandr/daypart',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          device: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/xandr/device',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['media_type', 'start_date', 'end_date', 'exclude_line_item_ids'],
            model: {
              one: '/dashboards/ihm_campaign/initiatives/{record}/xandr/device/model',
              params: {
                record: 'initiativeId'
              },
              queryParams: ['media_type', 'start_date', 'end_date', 'exclude_line_item_ids']
            }
          },
          geo: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/xandr/geo',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['media_type', 'start_date', 'end_date', 'exclude_line_item_ids']
          },
          marketplace: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/xandr/marketplace',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          publisher: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/xandr/publisher',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          reach: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/xandr/reach',
            params: {
              record: 'initiativeId'
            }
          },
          tactic: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/xandr/tactic',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['media_type', 'start_date', 'end_date', 'exclude_line_item_ids']
          },
          topPublishers: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/xandr/top_publishers',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          weekDay: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/xandr/weekday',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          }
        },
        displayStats: {
          one: '/dashboards/ihm_campaign/initiatives/{record}/display',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids'],
          creative: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/display/creative',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          }
        },
        gtStats: {
          one: '/dashboards/ihm_campaign/initiatives/{record}/gt',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids'],
          creative: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/gt/creative',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          geo: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/gt/geo',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          secondAction: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/gt/secondaction',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          storeVisit: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/gt/storevisit',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          tactic: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/gt/tactic',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          }
        },
        amazonStats: {
          one: '/dashboards/ihm_campaign/initiatives/{record}/amazon',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids'],
          category: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/amazon/category',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          creative: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/amazon/creative',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          mediaType: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/amazon/media_type',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          videoView: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/amazon/video_view',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          }
        },
        socialStats: {
          one: '/dashboards/ihm_campaign/initiatives/{record}/social',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids'],
          creative: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/social/creative',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          geoDMA: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/social/geo_dma',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          geoState: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/social/geo_state',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          publisher: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/social/publisher',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          },
          uniqueMetrics: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/social/uniquemetrics',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          }
        },
        prerollStats: {
          one: '/dashboards/ihm_campaign/initiatives/{record}/preroll',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids'],
          creative: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/preroll/creative',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          }
        },
        ottStats: {
          one: '/dashboards/ihm_campaign/initiatives/{record}/ott',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids'],
          creative: {
            one: '/dashboards/ihm_campaign/initiatives/{record}/ott/creative',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids']
          }
        }
      },
      v2: {
        initiativeSummary: {
          one: '/dashboards/ihm_campaign/v2/{record}/initiative_summary',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        totalHeroMetrics: {
          one: '/dashboards/ihm_campaign/v2/{record}/total_hero_metrics',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        campaignDailyStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/campaign_daily_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        campaignDailyImpsClicks: {
          one: '/dashboards/ihm_campaign/v2/{record}/daily_imps_clicks',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        reachFrequency: {
          one: '/dashboards/ihm_campaign/v2/{record}/reach_frequency',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        dailyReachAndFrequency: {
          one: '/dashboards/ihm_campaign/v2/{record}/daily_reach_frequency',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        impressionsByPublisher: {
          one: '/dashboards/ihm_campaign/v2/{record}/impressions_by_publisher',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        deviceModel: {
          one: '/dashboards/ihm_campaign/v2/{record}/device_model',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        device: {
          one: '/dashboards/ihm_campaign/v2/{record}/device',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        tacticPerformanceStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/tactic_performance',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        ott: {
          marketplace: {
            one: '/dashboards/ihm_campaign/v2/{record}/ott/marketplace',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
          },
          hourWatched: {
            one: '/dashboards/ihm_campaign/v2/{record}/ott/hour_watched',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
          },
          impressionsByDayStats: {
            one: '/dashboards/ihm_campaign/v2/{record}/ott/by_day',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
          },
          impressionsByDayPartStats: {
            one: '/dashboards/ihm_campaign/v2/{record}/ott/daypart',
            params: {
              record: 'initiativeId'
            },
            queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
          }
        },
        campaignMediaTypeStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/campaign_media_type_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        landingPagePerformanceStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/landing_page_performance_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_line_item_ids', 'include_line_item_ids', 'media_types']
        },
        landingPagePerformanceStatsByCreative: {
          one: '/dashboards/ihm_campaign/v2/creative/{record}/landing_page_performance_stats',
          params: {
            record: 'creativeId'
          }
        },
        campaignGeoStoreVisitStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/geo_store_visit_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        campaignGeoStoreVisitFlags: {
          one: '/dashboards/ihm_campaign/v2/{record}/geo_store_visit_flags',
          params: {
            record: 'initiativeId'
          }
        },
        campaignGeoCityStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/geo_city_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        campaignGeoStateStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/geo_state_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        campaignGeoDmaStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/geo_dma_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        campaignSocialTotalHeroMetrics: {
          one: '/dashboards/ihm_campaign/v2/{record}/total_social_engagement_metrics',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        campaignSocialDrillDownMetrics: {
          one: '/dashboards/ihm_campaign/v2/{record}/social_engagement_metrics',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        campaignVideoViewStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/video_view',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        campaignCreativeStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/campaign_creative_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['activeCreativeToggle', 'start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids', 'offset', 'itemsPerPage', 'orderFields']
        },
        campaignAgeStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/campaign_age_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        campaignGenderStats: {
          one: '/dashboards/ihm_campaign/v2/{record}/campaign_gender_stats',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        campaignAudioTopNetwork: {
          one: '/dashboards/ihm_campaign/v2/{record}/campaign/audio_top_network',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        campaignAudioAdCompletion: {
          one: '/dashboards/ihm_campaign/v2/{record}/campaign_audio_ad_completion',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        audioTopStations: {
          one: '/dashboards/ihm_campaign/v2/{record}/campaign_audio_top_stations',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        campaignBroadcastDelivery: {
          one: '/dashboards/ihm_campaign/v2/{record}/campaign_broadcast_cumulative_delivery',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids', 'station']
        },
        campaignDailyBroadcastDelivery: {
          one: '/dashboards/ihm_campaign/v2/{record}/campaign_broadcast_daily_cumulative_delivery',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'media_types', 'include_line_item_ids', 'exclude_line_item_ids', 'station']
        },
        campaignBroadcastStation: {
          one: '/dashboards/ihm_campaign/v2/{record}/campaign_broadcast_stations',
          params: {
            record: 'initiativeId'
          },
          queryParams: ['start_date', 'end_date', 'include_line_item_ids', 'exclude_line_item_ids']
        },
        broadcastImpressionGoals: {
          one: '/dashboards/ihm_campaign/v2/broadcast_impression_goals',
          queryParams: ['initiative_ids']
        }
      }
    },
    ihmCompany: {
      companyTotalStats: {
        one: '/dashboards/ihm_company/{record}/company_total_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['exclude_initiative_ids', 'include_initiative_ids', 'media_types', 'start_date', 'end_date']
      },
      companyDailyStats: {
        one: '/dashboards/ihm_company/{record}/company_daily_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
      },
      companyDailyMediaTypeImpStats: {
        one: '/dashboards/ihm_company/{record}/daily_media_type_imp_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
      },
      companyDailyMediaTypeClickStats: {
        one: '/dashboards/ihm_company/{record}/daily_media_type_click_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
      },
      companyMediaTypeStats: {
        one: '/dashboards/ihm_company/{record}/company_media_type_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['exclude_initiative_ids', 'media_types', 'include_initiative_ids', 'start_date', 'end_date']
      },
      publisherStats: {
        one: '/dashboards/ihm_company/{record}/publisher_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
      },
      companyVideoViewStats: {
        one: '/dashboards/ihm_company/{record}/video_view',
        params: {
          record: 'companyId'
        },
        queryParams: ['exclude_initiative_ids', 'include_initiative_ids', 'media_types', 'start_date', 'end_date']
      },
      companyCreativeStats: {
        one: '/dashboards/ihm_company/{record}/company_creative_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['activeCreativeToggle', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types', 'start_date', 'end_date', 'offset', 'orderFields', 'itemsPerPage']
      },

      deviceModel: {
        one: '/dashboards/ihm_company/{record}/device_model',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
      },
      device: {
        one: '/dashboards/ihm_company/{record}/device',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
      },
      tacticPerformanceStats: {
        one: '/dashboards/ihm_company/{record}/tactic_performance_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
      },
      geoCityStats: {
        one: '/dashboards/ihm_company/{record}/geo_city_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'media_types', 'exclude_initiative_ids', 'include_initiative_ids']
      },
      geoStateStats: {
        one: '/dashboards/ihm_company/{record}/geo_state_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'media_types', 'exclude_initiative_ids', 'include_initiative_ids']
      },
      geoDmaStats: {
        one: '/dashboards/ihm_company/{record}/geo_dma_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'media_types', 'exclude_initiative_ids', 'include_initiative_ids']
      },
      geoStoreVisitStats: {
        one: '/dashboards/ihm_company/{record}/geo_store_visit_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'media_types', 'exclude_initiative_ids', 'include_initiative_ids']
      },
      geoStoreVisitFlags: {
        one: '/dashboards/ihm_company/{record}/geo_store_visit_flags',
        params: {
          record: 'companyId'
        }
      },
      landingPagePerformanceStats: {
        one: '/dashboards/ihm_company/{record}/landing_page_performance_stats',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
      },
      companyAudioTopNetwork: {
        one: '/dashboards/ihm_company/{record}/company/audio_top_network',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
      },
      companyAudioAdCompletion: {
        one: '/dashboards/ihm_company/{record}/company_audio_ad_completion',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
      },
      companyBroadcastDelivery: {
        one: '/dashboards/ihm_company/{record}/company_broadcast_cumulative_delivery',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types', 'station']
      },
      companyDailyBroadcastDelivery: {
        one: '/dashboards/ihm_company/{record}/company_broadcast_daily_cumulative_delivery',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types', 'station']
      },
      companyBroadcastStations: {
        one: '/dashboards/ihm_company/{record}/company_broadcast_stations',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'include_initiative_ids', 'exclude_initiative_ids']
      },
      ott: {
        impressionsByDayStats: {
          one: '/dashboards/ihm_company/{record}/ott/by_day',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
        },
        impressionsByDayPartStats: {
          one: '/dashboards/ihm_company/{record}/ott/daypart',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
        },
        marketplace: {
          one: '/dashboards/ihm_company/{record}/ott/marketplace',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
        },
        hourWatched: {
          one: '/dashboards/ihm_company/{record}/ott/hour_watched',
          params: {
            record: 'companyId'
          },
          queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
        }
      },
      audioTopStations: {
        one: '/dashboards/ihm_company/{record}/company_audio_top_stations',
        params: {
          record: 'companyId'
        },
        queryParams: ['start_date', 'end_date', 'exclude_initiative_ids', 'include_initiative_ids', 'media_types']
      }
    }
  },
  details: {
    one: '/{record}',
    params: {
      record: 'reportId'
    }
  },
  facebook: {
    adCreatives: {
      preview: {
        many: '/facebook/adcreatives/preview',
        queryParams: {
          ad_account_id: '',
          ad_format: 'DESKTOP_FEED_STANDARD',
          ids: ''
        }
      }
    },
    customConversions: {
      many: '/facebook/customconversions',
      queryParams: ['ad_account_id']
    }
  },
  google: {
    adWords: {
      adGroups: {
        many: '/google/adwords/adgroups',
        queryParams: ['campaign_ids']
      },
      ads: {
        many: '/google/adwords/ads',
        queryParams: ['adgroup_ids']
      },
      campaigns: {
        many: '/google/adwords/campaigns',
        queryParams: ['campaign_ids']
      },
      reportStats: {
        adGroups: {
          many: '/google/adwords/reportstats/adgroups',
          queryParams: ['end_date', 'ids', 'line_item_id', 'start_date']
        },
        ads: {
          many: '/google/adwords/reportstats/ads',
          queryParams: ['end_date', 'ids', 'line_item_id', 'start_date']
        },
        campaigns: {
          many: '/google/adwords/reportstats/campaigns',
          queryParams: ['end_date', 'ids', 'line_item_id', 'start_date']
        }
      },
      videos: {
        many: '/google/adwords/videos',
        queryParams: ['ad_ids']
      }
    }
  },
  linkedin: {
    adAccounts: {
      one: '/linkedin/adaccounts/{record}',
      params: {
        record: 'account_id'
      }
    },
    campaignGroups: {
      many: '/linkedin/campaign_groups',
      queryParams: ['campaign_group_ids']
    },
    campaigns: {
      many: '/linkedin/campaigns',
      queryParams: ['campaign_ids']
    },
    adCreatives: {
      many: '/linkedin/creatives',
      queryParams: ['campaign_ids']
    },
    reportStats: {
      many: '/linkedin/reportstats',
      queryParams: ['ids', 'dateRange.start.day', 'dateRange.start.month', 'dateRange.start.year', 'dateRange.end.day', 'dateRange.end.month', 'dateRange.end.year', 'pivot']
    },
    sponsoredInmails: {
      many: '/linkedin/sponsored_inmails',
      queryParams: ['sponsored_inmail_ids']
    },
    shares: {
      many: '/linkedin/shares',
      queryParams: ['share_ids']
    },
    ugcPosts: {
      many: '/linkedin/ugc_posts',
      queryParams: ['ugc_post_ids']
    }
  },
  initiatives: {
    stats: {
      one: '/initiatives/{record}/stats',
      params: {
        record: 'initiativeId'
      }
    }
  },
  instagram: {
    adCreatives: {
      preview: {
        many: '/instagram/adcreatives/preview',
        queryParams: {
          ad_account_id: '',
          ad_format: 'INSTAGRAM_STANDARD',
          ids: ''
        }
      }
    }
  },
  twitter: {
    customConversions: {
      many: '/twitter/accounts/{parent}/web_event_tags',
      queryParams: ['ad_account_id'],
      params: {
        parent: 'ad_account_id'
      }
    }
  },
  investments: {
    brands: {
      many: '/investments/brands',
      queryParams: ['brand_id', 'company_id', 'currency', 'end_date', 'family_id', 'start_date']
    },
    creatives: {
      many: '/investments/creatives',
      queryParams: ['brand_id', 'company_id', 'creative_type', 'currency', 'end_date', 'family_id', 'initiative_id', 'lineitem_id', 'publisher', 'start_date'],
      report: {
        one: '/investments/creatives/report',
        queryParams: ['async', 'brand_id', 'company_id', 'creative_type', 'currency', 'email', 'end_date', 'family_id', 'format', 'initiative_id', 'lineitem_id', 'low_media_spend', 'publisher', 'start_date']
      }
    }
  },
  lineItems: {
    campaigns: {
      pacing: {
        many: '/line_items/{parent}/campaigns/pacing',
        params: {
          parent: 'lineItemId'
        }
      }
    },
    pacing: {
      many: '/line_items/pacing',
      one: '/line_items/{record}/pacing',
      params: {
        record: 'lineItemId'
      },
      queryParams: ['archived', 'disabled', 'include_li', 'initiativeID', 'limit', 'with_goals', 'withAccess']
    }
  },

  amazon: {
    reportStats: {
      many: '/amazon/reportstats/orders',
      queryParams: ['credentialId', 'ad_account_id', 'request_type', 'end_date', 'metrics', 'start_date', 'ids', 'litmit']
    }
  },

  tiktok: {
    reportStats: {
      many: '/tiktok/reportstats/campaigns',
      queryParams: ['credentialId', 'ad_account_id', 'request_type', 'fields', 'start_time', 'end_time', 'ids', 'limit']
    }
  },

  list: '/',

  pinterest: {
    adGroups: {
      many: '/pinterest/custom/ad_groups',
      queryParams: ['campaign_ids']
    },
    campaigns: {
      many: '/pinterest/custom/campaigns',
      queryParams: ['ids']
    },
    deliveryMetrics: {
      many: '/pinterest/custom/delivery_metrics',
      queryParams: ['ad_group_ids', 'campaign_ids', 'click_window_days', 'conversion_report_time', 'end_date', 'engagement_window_days', 'granularity', 'pin_promotion_ids', 'start_date', 'tag_version', 'view_window_days']
    },
    pinPreviews: {
      many: '/pinterest/custom/pins/previews',
      queryParams: ['ids']
    },
    pinPromotions: {
      many: '/pinterest/custom/pin_promotions',
      queryParams: ['ad_group_ids']
    }
  },
  resources: {
    customMetrics: {
      one: '/resources/custom_metrics',
      queryParams: ['brand_id', 'company_id', 'disabled', 'publisher']
    },
    dynamicMetrics: {
      one: '/resources/dynamic_metrics',
      queryParams: ['ad_account_id', 'brand_id', 'publisher', 'is_custom_metric_eligible']
    },
    standardMetrics: {
      one: '/resources/standard_metrics',
      queryParams: ['publisher', 'is_custom_metric_eligible']
    },
    syncedAdAccount: {
      many: '/resources/ad_accounts',
      queryParams: ['pacing_report']
    }
  },
  salesforce: {
    orderLineItem: {
      one: '/salesforce/order_line_item/{record}',
      params: {
        record: 'foreign_id'
      }
    },
    orderLineItemV2: {
      one: '/resources/query/v_reporting_salesforce_order_line_item',
      queryParams: ['query']
    }
  },
  segmentation: {
    cohortTaxonomy: {
      many: '/segmentation/get_cohort_taxonomy',
      queryParams: ['client_name', 'taxonomy_type']
    },
    unifiedCohortTaxonomy: {
      many: '/segmentation/unified/get_cohort_taxonomy',
      queryParams: ['client_name', 'taxonomy_type']
    },
    pagesAudiences: {
      many: '/segmentation/get_pages_audiences',
      queryParams: ['client_name', 'audience_type', 'audience_ids']
    }
  },
  segmentationBroadcast: {
    audienceAggregator: {
      audienceSize: {
        many: '/segmentation/broadcast/audience_aggregator/get_audience_size',
        queryParams: ['client_name', 'type', 'type_ids', 'record_count', 'order_by', 'cohort_path', 'return_direct_children_only']
      },
      keyMetric: {
        many: '/segmentation/broadcast/audience_aggregator/get_key_metric',
        queryParams: ['client_name', 'type', 'type_ids', 'key_metric']
      },
      segmentation: {
        many: '/segmentation/broadcast/audience_aggregator/get_segmentation',
        queryParams: ['client_name', 'type', 'type_ids', 'record_count', 'order_by', 'cohort_path', 'return_direct_children_only', 'index_id']
      },
      indexBaselineDetail: {
        many: '/segmentation/broadcast/audience_aggregator/get_index_baseline_detail',
        queryParams: ['client_name']
      }
    },
    brandArtistList: {
      many: '/segmentation/broadcast/audience_brand_explorer/get_brand_artist_list',
      queryParams: ['client_name']
    },
    brandArtistSegmentation: {
      many: '/segmentation/broadcast/audience_brand_explorer/get_brand_artist_segmentation',
      queryParams: ['client_name', 'artist_name']
    },
    brandOverlapSegmentation: {
      many: '/segmentation/broadcast/audience_brand_explorer/get_brand_overlap_segmentation',
      queryParams: ['client_name', 'cohort_id']
    },
    brandSegmentation: {
      many: '/segmentation/broadcast/audience_brand_explorer/get_brand_segmentation',
      queryParams: ['client_name']
    },
    audienceSize: {
      many: '/segmentation/broadcast/audience_creator/get_audience_size',
      queryParams: ['ages', 'client_name', 'cohort_id', 'genders', 'index_baseline']
    },
    cohortSegmentation: {
      many: '/segmentation/broadcast/audience_creator/get_cohort_segmentation',
      queryParams: ['ages', 'client_name', 'cohort_path', 'gender']
    },
    unitSegmentation: {
      many: '/segmentation/broadcast/audience_creator/get_unit_segmentation',
      queryParams: ['ages', 'audience_type', 'client_name', 'cohort_id', 'gender', 'index_baseline']
    },
    indexBaselineLayeredDetail: {
      many: '/segmentation/broadcast/audience_creator/get_index_baseline_layered_detail',
      queryParams: ['ages', 'genders', 'client_name', 'cohort_id']
    }
  },
  // record is either 'unified' or 'client' (for iHeart)
  segmentationDigital: {
    audienceSize: {
      one: '/{record}/digital/get_audience_size',
      params: {
        record: 'client'
      },
      queryParams: ['client_name', 'dataset_name', 'type_id', 'type']
    },
    keyMetrics: {
      one: '/{record}/digital/key_metrics',
      params: {
        record: 'client'
      },
      queryParams: ['client_name', 'dataset_name', 'type_id', 'type']
    },
    report: {
      one: '/{record}/digital/get_segmentation_report',
      params: {
        record: 'client'
      },
      queryParams: ['client_name', 'cohort_path', 'dataset_name', 'order_by', 'record_count', 'type_id', 'type', 'user_num_range']
    },
    segmentationReport: {
      many: '/client/digital/segmentation_report',
      queryParams: ['client_name', 'cohort_path', 'dataset_name', 'order_by', 'record_count', 'type_id', 'type', 'user_num_range']
    }
  },
  exportReport: {
    reportEmail: {
      one: '/{record}/paid',
      params: {
        record: 'publisher'
      },
      body: {
        ad_account_id: 'ad_account_id',
        async: 'async',
        attr_window: 'attr_window',
        billing_bundle_id: 'billing_bundle_id',
        brand_id: 'brand_id',
        click_attr: 'click_attr',
        columns: 'columns',
        company_id: 'company_id',
        cost_calculation: 'cost_calculation',
        daterange_preset: 'daterange_preset',
        delivery_daterange_preset: 'delivery_daterange_preset',
        delivery_end_date: 'delivery_end_date',
        delivery_start_date: 'delivery_start_date',
        email: 'email',
        end_date: 'end_date',
        exclude_unified_id: 'exclude_unified_id',
        export_breakout: 'export_breakout',
        export_params: 'export_params',
        family_id: 'family_id',
        filename: 'filename',
        format: 'format',
        include_attribution: 'include_attribution',
        include_custom_metrics: 'include_custom_metrics',
        include_summary: 'include_summary',
        initiative_id: 'initiative_id',
        initiative_group_id: 'initiative_group_id',
        is_ihm_platform: 'is_ihm_platform',
        line_item_id: 'line_item_id',
        opportunity_id: 'opportunity_id',
        report_level: 'report_level',
        saved_report_id: 'saved_report_id',
        saved_report_name: 'saved_report_name',
        section: 'section',
        start_date: 'start_date',
        swipe_up_attribution_window: 'swipe_up_attribution_window',
        template_id: 'template_id',
        view_attr: 'view_attr',
        view_attribution_window: 'view_attribution_window',
        xlsx_format_version: 'xlsx_format_version'
      }
    },
    createReportPassThrough: {
      one: '/reporting/reports',
      noPrefix: true,
      body: {
        input: 'input',
        output: 'output'
      }
    },
    reportRawData: {
      one: '/{record}/paid/raw',
      params: {
        record: 'publisher'
      },
      queryParams: ['ad_account_id', 'async', 'attr_window', 'breakdown', 'brand_id', 'click_attr', 'columns', 'company_id', 'cost_calculation', 'daterange_preset', 'delivery_daterange_preset', 'delivery_start_date', 'delivery_end_date', 'email', 'end_date', 'exclude_unified_id', 'export_breakout', 'family_id', 'filename', 'format', 'include_attribution', 'include_custom_metrics', 'include_summary', 'initiative_id', 'line_item_id', 'report_level', 'saved_report_id', 'saved_report_name', 'start_date', 'swipe_up_attribution_window', 'template_id', 'view_attr', 'view_attribution_window']
    },
    previewTemplate: {
      one: '/{record}/paid/preview',
      params: {
        record: 'publisher'
      },
      body: {
        name: 'name',
        parameters: 'parameters',
        publisher: 'publisher'
      }
    }
  }
  /* eslint-enable sort-keys */

};var defaultOptions = {
  prefix: '/reports'
};

var ReportsApi = function (_PlatformApi) {
  (0, _inherits3.default)(ReportsApi, _PlatformApi);

  function ReportsApi(options) {
    (0, _classCallCheck3.default)(this, ReportsApi);

    var o = (0, _assign2.default)({}, defaultOptions, options);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportsApi.__proto__ || (0, _getPrototypeOf2.default)(ReportsApi)).call(this, o));

    _this._endpoints = endpoints;
    return _this;
  }

  (0, _createClass3.default)(ReportsApi, null, [{
    key: 'getReportId',
    value: function getReportId(value) {
      var valueLower = value.toLowerCase();

      var ids = _reportIds2.default.filter(function (report) {
        return report.uriTemplate === value || (0, _startsWith2.default)(report.name.toLowerCase(), valueLower);
      });

      if (!ids.length) return;

      // If more than one match is found, return all; otherwise, return single ID
      return ids.length === 1 ? ids[0].id : ids.map(function (report) {
        return report.id;
      });
    }
  }, {
    key: 'getReportName',
    value: function getReportName(value) {
      // Always return first report matched
      var firstMatch = (0, _find2.default)(_reportIds2.default, function (report) {
        return report.uriTemplate === value || (0, _startsWith2.default)(report.id, value);
      });

      return firstMatch && firstMatch.name;
    }
  }]);
  return ReportsApi;
}(_PlatformApi3.default);

exports.default = ReportsApi;
//# sourceMappingURL=ReportsApi.js.map